import config from 'config/config'
import { I18n } from 'lib/i18n'
import { findDOMNode } from 'react-dom'
import { Observable } from 'rxjs'
import request from 'superagent'

// gets the errors from the backend and turns them into a list of strings containing the errors
export const renderErrors = (errors) => {
  if (!errors) return []
  return Object.keys(errors).map(
    (key) =>
      I18n.t('error_keys.' + key) +
      ': ' +
      errors[key]
        .map((error) => I18n.t('error_values.' + error.error))
        .join(', ')
  )
  //  return Object.keys(errors).map(key => errors[key].map(error => I18n.t('error_keys.' + key) + ': ' + I18n.t('error_values.' + error.error))).join(', ');
}

const baseURL =
  process.env.NODE_ENV === 'test' ? 'http://127.0.0.1' : config.api_url

export const CHF = (amount) => {
  return Intl.NumberFormat('de-CH', config.format.currency.CHF).format(amount).replace(/-/, ' -')
}

export const classNames = (classNames) => {
  return classNames && Array.isArray(classNames)
    ? Array.join(classNames.filter((className) => className), ' ')
    : false
}

export const sort = (a, b, sortCol) => {
  let { [sortCol]: aValue = '' } = a
  let { [sortCol]: bValue = '' } = b
  if (aValue === null) aValue = ''
  if (bValue === null) bValue = ''

  if (typeof aValue === 'number') {
    return aValue - bValue
  } else if (typeof aValue === 'boolean') {
    return Number(aValue) - Number(bValue)
  } else {
    return aValue.localeCompare(bValue)
  }
}

export const sortOld = (a, b, sortCol) => {
  const aNumber = Number(a[sortCol])
  const bNumber = Number(b[sortCol])
  const aNaN = isNaN(aNumber)
  const bNaN = isNaN(bNumber)
  if (!aNaN && !bNaN) return aNumber - bNumber
  if (!aNaN && bNaN) return -1
  if (aNaN && !bNaN) return 1
  if (a[sortCol] < b[sortCol]) return -1
  if (a[sortCol] > b[sortCol]) return 1
  return 0
}

export const upload = (url, files, method, progressCallback) => {
  let req
  if (method === 'PUT') {
    req = request
      .put(baseURL + url)
      .set('Token', localStorage.getItem('userToken'))
  } else {
    req = request
      .post(baseURL + url)
      .set('Token', localStorage.getItem('userToken'))
  }

  if (Object.prototype.toString.call(files) === '[object Array]') {
    files.forEach((file) => {
      req.attach(file.name, file)
    })
  } else {
    req.attach(files.name, files)
  }
  req.on('progress', (e) => {
    if (progressCallback) progressCallback(e.percent)
  })
  return Observable.from(
    req
    /*
     request.post(baseURL + url)
     .set('Token', localStorage.getItem('userToken'))
     .attach(file.name, file)
     */
  )
    .map((result) => {
      const { body, status, ok, error } = result
      return { body, status, ok, error }
    })
    .catch((result) => {
      let { body, status, ok, error } = result.response
      let renderedErrors = null
      if (body && body.errors) renderedErrors = renderErrors(body.errors)
      return Observable.of({ body, status, ok, error, renderedErrors })
    })
}

export const post = (url, payload) => {
  return Observable.from(
    request
      .post(baseURL + url)
      .set('Token', localStorage.getItem('userToken'))
      .send(payload)
  )
    .map((result) => {
      const { body, status, ok, error } = result
      return { body, status, ok, error }
    })
    .catch((result) => {
      let { body, status, ok, error } = result.response
      let renderedErrors = null
      if (body && body.errors) renderedErrors = renderErrors(body.errors)
      return Observable.of({ body, status, ok, error, renderedErrors })
    })
}

export const put = (url, payload) => {
  return Observable.from(
    request
      .put(baseURL + url)
      .set('Token', localStorage.getItem('userToken'))
      .send(payload)
  )
    .map((result) => {
      const { body, status, ok, error } = result
      return { body, status, ok, error }
    })
    .catch((result) => {
      let { body, status, ok, error } = result.response
      let renderedErrors = null
      if (body && body.errors) renderedErrors = renderErrors(body.errors)
      return Observable.of({ body, status, ok, error, renderedErrors })
    })
}

export const patch = (url, payload) => {
  return Observable.from(
    request
      .patch(baseURL + url)
      .set('Token', localStorage.getItem('userToken'))
      .send(payload)
  )
    .map((result) => {
      const { body, status, ok, error } = result
      return { body, status, ok, error }
    })
    .catch((result) => {
      let { body, status, ok, error } = result.response
      let renderedErrors = null
      if (body && body.errors) renderedErrors = renderErrors(body.errors)
      return Observable.of({ body, status, ok, error, renderedErrors })
    })
}

export const del = (url, payload) => {
  return Observable.from(
    request
      .delete(baseURL + url)
      .set('Token', localStorage.getItem('userToken'))
      .send(payload)
  )
    .map((result) => {
      const { body, status, ok, error } = result
      return { body, status, ok, error }
    })
    .catch((result) => {
      let { body, status, ok, error } = result.response
      let renderedErrors = null
      if (body && body.errors) renderedErrors = renderErrors(body.errors)
      return Observable.of({ body, status, ok, error, renderedErrors })
    })
}

export const get = (url) => {
  return Observable.from(
    request.get(baseURL + url).set('Token', localStorage.getItem('userToken'))
  )
    .map((result) => {
      const { body, text, status, ok, error } = result
      return { body, text, status, ok, error }
    })
    .catch((result) => {
      if (result.response) {
        let { body, status, ok, error } = result.response
        let renderedErrors = null
        if (body && body.errors) renderedErrors = renderErrors(body.errors)
        return Observable.of({ body, status, ok, error, renderedErrors })
      }
      return Observable.of({ status: result.status })
    })
}

export const sortableListDragSource = {
  beginDrag: (props) => {
    if (props.beginDrag) props.beginDrag()
    return {
      dragId: props.dragId,
      originalIndex: props.findItem(props.dragId).index,
    }
  },
  isDragging: (props, monitor) => {
    return props.dragId === monitor.getItem().dragId
  },
  endDrag: (props, monitor, component) => {
    console.debug('utilities:endDrag:props', props)
    console.debug('utilities:endDrag:props', monitor)
    console.debug('utilities:endDrag:props', component)
  },
}

export const sortableListDropTarget = {
  canDrop: () => true,
  hover: (props, monitor, component) => {
    const { dragId: draggedId } = monitor.getItem()
    const { dragId: overId } = props
    if (draggedId !== overId) {
      const { index: overIndex } = props.findItem(overId)
      const { index: draggedIndex } = props.findItem(draggedId)
      props.moveItem(draggedIndex, overIndex)
    }
  },
}

export const sortableListDropTargetNew = {
  canDrop: () => true,
  hover: (props, monitor, component) => {
    const { dragId: draggedId } = monitor.getItem()
    const { dragId: overId, dragMarker = {}, setDragMarker } = props
    if (draggedId !== overId) {
      const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2 +
        hoverBoundingRect.top
      const clientOffset = monitor.getClientOffset()
      const { index: overIndex } = props.findItem(overId)
      const position = clientOffset.y > hoverMiddleY ? 'below' : 'above'
      if (dragMarker.index !== overIndex || dragMarker.position !== position) {
        setDragMarker({ index: overIndex, position: position })
      }
    }
  },
  drop: (props, monitor, component) => {
    const { dragId: draggedId } = monitor.getItem()
    const { dragId: overId, setDragMarker } = props
    setDragMarker({})
    if (draggedId !== overId) {
      const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2 +
        hoverBoundingRect.top
      const clientOffset = monitor.getClientOffset()
      const { index: overIndex } = props.findItem(overId)
      const { index: draggedIndex } = props.findItem(draggedId)
      const lowerHalf = clientOffset.y > hoverMiddleY
      let targetIndex
      if (overIndex > draggedIndex) {
        if (lowerHalf) targetIndex = overIndex
        else targetIndex = overIndex - 1
      } else {
        if (lowerHalf) targetIndex = overIndex + 1
        else targetIndex = overIndex
      }
      props.moveItem(draggedIndex, targetIndex)
    }
  },
}

export const sortableListDragSourceDragMarker = {
  beginDrag: (props) => {
    if (props.beginDrag) props.beginDrag()
    return {
      dragId: props.dragId,
      originalIndex: props.findItem(props.dragId).index,
    }
  },
  isDragging: (props, monitor) => {
    return props.dragId === monitor.getItem().dragId
  },
  endDrag: (props /*,monitor,component*/) => {
    const { setDragMarker } = props
    setDragMarker({})
    console.debug(
      'utilities:endDrag:props',
      props.index,
      props.dragMarker.targetIndex
    )
    if (props.index !== props.dragMarker.targetIndex)
      props.moveItem(props.index, props.dragMarker.targetIndex)
  },
}

export const sortableListDropTargetDragMarker = {
  canDrop: () => true,
  hover: (props, monitor, component) => {
    const { dragId: draggedId } = monitor.getItem()
    const { dragId: overId, dragMarker = {}, setDragMarker } = props
    if (draggedId !== overId) {
      const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2 +
        hoverBoundingRect.top
      const clientOffset = monitor.getClientOffset()
      const { index: overIndex } = props.findItem(overId)
      const { index: draggedIndex } = props.findItem(draggedId)
      const lowerHalf = clientOffset.y > hoverMiddleY
      // Determine the targetIndex for array.move
      let targetIndex
      if (overIndex > draggedIndex) {
        if (lowerHalf) targetIndex = overIndex
        else targetIndex = overIndex - 1
      } else {
        if (lowerHalf) targetIndex = overIndex + 1
        else targetIndex = overIndex
      }
      // determine the drag mark position
      let index = overIndex
      // ony use dragAbove for the first element, so the marker doesn't jump
      let position = 'dragBelow'
      if (!lowerHalf && ((draggedIndex === 0 && index === 1) || index === 0))
        position = 'dragAbove'
      else if (!lowerHalf) {
        if (index === draggedIndex + 1) index -= 2
        else index--
      } else if (!lowerHalf) index--
      /*
            ////// simpler variant
            const position = lowerHalf ? 'dragBelow' : 'dragAbove';
      */
      if (dragMarker.index !== index || dragMarker.position !== position) {
        setDragMarker({ index, position, targetIndex })
      }
    }
  },
}

// drag hover lower
// 0    1     false -> 0 0
// 0    1     true  -> 0 1
// 1    0     true  -> 1 1
// 1    0     false -> 1 0
// 0    2     false -> 0 1
// 0    2     true  -> 0 2
// 2    0     true  -> 2 1
// 2    0     false -> 2 0



// WEBPACK FOOTER //
// ./src/lib/utilities.js